<template>
  <!-- Displays a welcome message and a tip of the day -->
  <div id="mainContainer">
    <h1>{{pageText.title[selectedLang]}}</h1>
    <!-- Main container -->
    <div id="content">
      <!-- Welcome message -->
      <div id="description">
        <p v-html="pageText.content.description[selectedLang]"></p>
      </div>
      <!-- Tip of the day -->
      <div id="tip">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">{{pageText.content.tip.legend[selectedLang]}}</h5>
            <h6 class="card-subtitle text-muted">{{pageText.content.tip.description[selectedLang]}}</h6>
            <p class="card-text" v-html="tip.question"></p>
            <ul>
                <li v-for="choice in tip.choices" v-bind:key="choice" v-html="choice"></li>
            </ul>
            <div id="showTextButton" v-on:click="showAnswer()">
              <b class="card-link btn btn-primary">{{pageText.content.tip.answer[selectedLang]}}</b>
            </div>
            <p v-if="showTipAnswer" class="card-text" v-html="tip.answer"></p>
            <p v-if="showTipAnswer" class="card-text" v-html="tip.comment"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getRandomTip} from '../utils.js'

export default {
  name: 'About',
  props : {
    selectedLang : String
  },
  methods : {
    /**
     * Enable/Disable showing tip's answer
     */
    showAnswer() {
      this.showTipAnswer = !this.showTipAnswer;
    }
  },
  data () {
    return {
      // Static text on the page
      // available in english, dutch and french
      pageText : {
        title : {
          en : "About the UCL - KUL terminology website",
          fr : "A propos du site de terminologie UCL-KUL",
          nl : "Over de KUL - UCL terminologie website"
        },
        content : {
          description : {
            en : "This site is provided by the <em>Centre for English Corpus Linguistics</em> at UCL and the <em>Interfacultair Instituut voor Levende Talen</em> at KUL.",
            fr : "Ce site est mis à votre disposition par le <em>Centre for English Corpus Linguistics</em> de l'UCL et l'<em>Interfacultair Instituut voor Levende Talen</em> de la KUL.",
            nl : "Deze site wordt ter beschikking gesteld door het <em>Centre for English Corpus Linguistics</em> aan de UCL en het <em>Interfacultair Instituut voor Levende Talen</em> aan de KUL."
          },
          tip : {
            legend : {
              en : "Tip of the day",
              fr : "Conseil du jour",
              nl : "Tip van de dag"
            },
            description : {
              en : "A quick tip on each visit",
              fr : "Un petit conseil à chaque visite",
              nl : "Een korte tip bij elk bezoek"
            },
            answer : {
              en : "Click here to show the answer",
              fr : "Cliquez ici pour afficher la solution",
              nl : "Klik hier om het antwoord te tone"
            },
          }
        }
      },
      // Where the tips will be shown
      tip : "",
      // Enable/Disable showing tip's answer
      showTipAnswer : false
    }
  },
  // On load function
  created : function () {
    // Query server for a tip
    getRandomTip((d) => {
        // In case of success, retreive the tip
        this.tip = d
      }, (_) => {
        // In case of failure, do nothing
      })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

h1 {
  text-align: center;
  font-size: 2vw;
}

#mainContainer {
  margin-left: auto;
  width: 100%;
  height: 95%;
}

#content {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

#description, #tip {
  width: 40%;
  height: 100%;
}

#showTextButton{
  width: 100%;
  text-align: center;
  cursor: pointer;
}

#showTextButton b:hover {
  text-decoration: underline;
}

#showTextButton b {
  color : rgba(255, 255, 255, 0.8);
}

.btn-primary {
  background-color: #00214e;
  border : 1px solid #00214e;
}

@media screen and (max-width: 850px) {
  h1 {
    font-size: 10vw;
  }

  #content {
    flex-direction: column;
  }

  #description, #tip {
    width: 100%;
  }
}

@media screen and (max-width: 850px) and (orientation : landscape){
  h1 {
    font-size: 5vw;
  }
  
  #content {
    flex-direction: row;
  }
}

</style>
